import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { AppState, ModuleId } from '../../types';
import { GroupId } from '../../config/systemConfig';
import { MODULES } from '../../data/questionLoader';
import { getAllModuleTrends } from '../../utils/activityHelpers';
import { ArrowUpRight, ArrowRight, ArrowDownRight } from 'lucide-react';
import * as Icons from 'lucide-react';
interface SubjectProgressGridProps {
  learnerData: AppState;
  selectedGroup: GroupId;
  getModuleMastery: (moduleId: ModuleId) => number;
}
export function SubjectProgressGrid({
  learnerData,
  selectedGroup,
  getModuleMastery
}: SubjectProgressGridProps) {
  const trends = getAllModuleTrends(learnerData.familyMastery || {}, selectedGroup);
  return <Card className="p-6" data-id="element-4371">
      <h3 className="text-xl font-black text-slate-900 mb-6" data-id="element-4372">
        Voortgang per Vak
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-4373">
        {MODULES.map((module, index) => {
        const mastery = getModuleMastery(module.id);
        const filledDots = Math.ceil(mastery / 25); // 4 dots total
        const trend = trends[module.id];
        let statusLabel = 'Nieuw';
        let statusVariant: any = 'neutral';
        if (mastery >= 95) {
          statusLabel = 'Klaar! ⭐';
          statusVariant = 'success';
        } else if (mastery >= 50) {
          statusLabel = 'Bijna klaar';
          statusVariant = 'info';
        } else if (mastery > 0) {
          statusLabel = 'Bezig';
          statusVariant = 'primary';
        }
        return <motion.div key={module.id} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: index * 0.05
        }} className="p-4 rounded-2xl border border-slate-200 bg-slate-50 hover:bg-white hover:border-emerald-200 transition-colors" data-id="element-4374">
              <div className="flex items-start justify-between mb-4" data-id="element-4375">
                <div className="flex items-center gap-3" data-id="element-4376">
                  <div className="w-10 h-10 rounded-xl bg-white shadow-sm flex items-center justify-center" data-id="element-4377">
                    {(() => {
                  const IconComp = (Icons as any)[module.icon] || Icons.BookOpen;
                  return <IconComp className="w-5 h-5 text-emerald-600" data-id="element-4378" />;
                })()}
                  </div>
                  <div data-id="element-4379">
                    <h4 className="font-bold text-slate-800 flex items-center gap-1" data-id="element-4380">
                      {module.title}
                      {trend === 'up' && <ArrowUpRight className="w-4 h-4 text-emerald-500" title="Vooruitgang deze week" data-id="element-4381" />}
                      {trend === 'down' && <ArrowDownRight className="w-4 h-4 text-rose-500" title="Moeite deze week" data-id="element-4382" />}
                      {trend === 'stable' && mastery > 0 && <ArrowRight className="w-4 h-4 text-slate-300" title="Stabiel" data-id="element-4383" />}
                    </h4>
                  </div>
                </div>
                <Badge variant={statusVariant} size="sm" data-id="element-4384">
                  {statusLabel}
                </Badge>
              </div>

              <div className="flex gap-1.5" data-id="element-4385">
                {Array.from({
              length: 4
            }).map((_, i) => <div key={i} className={`h-2 flex-1 rounded-full ${i < filledDots ? 'bg-emerald-500' : 'bg-slate-200'}`} data-id="element-4386" />)}
              </div>
            </motion.div>;
      })}
      </div>
    </Card>;
}